import { render, staticRenderFns } from "./ProjectLanding.vue?vue&type=template&id=48d2eb28&scoped=true&"
import script from "./ProjectLanding.vue?vue&type=script&lang=js&"
export * from "./ProjectLanding.vue?vue&type=script&lang=js&"
import style0 from "./ProjectLanding.vue?vue&type=style&index=0&id=48d2eb28&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d2eb28",
  null
  
)

export default component.exports